<template>
  <div
    v-if="shouldRender"
    class="d-flex flex-column ga-4"
    data-testid="dashboard-family-subsidy-programs"
  >
    <h2 class="fs-24">
      {{ $bct('Other programs you might be interested in') }}
    </h2>

    <DashboardFamilySubsidyProgram
      v-for="item in familySubsidyPrograms"
      @create="createFamilySubsidy"
      :key="item.id"
      :family-subsidy-program="item"
      :processing="processing"
    />
  </div>
</template>

<script setup>
import DashboardFamilySubsidyProgram from '@/parent/components/dashboards/DashboardFamilySubsidyProgram.vue';

const props = defineProps({
  familySubsidyPrograms: {
    type: Array,
    default: () => [],
  },
  processing: {
    type: Boolean,
  },
});

const emit = defineEmits(['create']);

const $bct = inject('translator');

const createFamilySubsidy = (familySubsidyProgram) => {
  emit('create', familySubsidyProgram);
};

const shouldRender = computed(() => {
  return props.familySubsidyPrograms.length > 0;
});
</script>
